import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Paged } from '../models/paged.dto';
import { Patient } from '../models/patient.entity';
import { Page } from 'ngx-pagination';
import { BraceletCredentialInfo } from '../models/bracelet-credential-info.dto';

@Injectable({
  providedIn: 'root',
})
export class PatientService {
  private selectedPatientSubject = new BehaviorSubject<any>(null); // Contiene il paziente selezionato
  selectedPatient$ = this.selectedPatientSubject.asObservable(); // Observable per il paziente selezionato

  constructor(private http: HttpClient) {}

  public getAllPazienti(
    search: string,
    page: number,
    size: number
  ): Observable<Paged> {
    let params = new HttpParams()
      .set('search', search)
      .set('page', page.toString())
      .set('size', size.toString());

    return this.http.get<Paged>(environment.backendUrl + '/paziente', {
      params: params,
    });
  }

  public getPazienteByCf(fiscalCode: string) {
    return this.http.get<Patient>(
      environment.backendUrl + '/paziente/find/' + fiscalCode
    );
  }

  public savePaziente(patient: Patient) {
    return this.http.post<Patient>(
      environment.backendUrl + '/paziente/save',
      patient
    );
  }

  public getPatientUserInfo(request: any) {
    return this.http.post<BraceletCredentialInfo>(
      environment.backendUrl + '/bracelet/exist' , request
    );
  }

  public createPatientUser() {
    return of({active: true});
  }

  public activatePatientUser(request: any) {
    return this.http.post<any>(
      environment.backendUrl + '/bracelet/activate' , request
    );
  }

  public reactivatePatientUser(request: any) {
    return this.http.post<any>(
      environment.backendUrl + '/bracelet/reactivate' , request
    );
  }

  public deactivatePatientUser(request: any) {
    return this.http.post<any>(
      environment.backendUrl + '/bracelet/deactivate' , request
    );
  }

  public deletePatientUser(request: any) {
    return this.http.delete<any>(
      environment.backendUrl + '/bracelet/delete' , { body: request}
    );
  }

  public patchPaziente(patient: any) {
    return this.http.patch<Patient>(
      environment.backendUrl + '/paziente/aggiorna',
      patient
    );
  }

  public getPatientByEhrid(ehrid: string) {
    return this.http.get<Patient>(
      environment.backendUrl + '/paziente/find/ehrId/' + ehrid
    );
  }

  checkFiscalCode(fiscalCode: string): Observable<boolean> {
    return this.http.get<boolean>(
      environment.backendUrl + `/paziente/check/${fiscalCode}`
    );
  }

  selectPatient(patient: Patient) {
    this.selectedPatientSubject.next(patient);
  }

  getSelectedPatient(): Patient {
    return this.selectedPatientSubject.value;
  }

  clearSelectedPatient() {
    this.selectedPatientSubject.next(null);
  }
}
